export default "__VITE_ASSET__Zbq6yBuh__"